"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartTableCell = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = require("../../ui/Icon");
var Checkbox_1 = require("../../ui/Checkbox");
var Helpers_1 = require("../../util/Helpers");
var IconSymbols_1 = require("../../generated/IconSymbols");
var SmartTableCell = function (_a) {
    var col = _a.col, row = _a.row;
    if (col.id === "actions") {
        return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: IconSymbols_1.IconSymbols.DotsHorizontal });
    }
    if (col.id === "checkbox") {
        return ((0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { onChange: function (e) {
                row.setIsChecked(e.currentTarget.checked);
            }, checked: row.isChecked }));
    }
    if (col.cellContentFunction) {
        return col.cellContentFunction(row, row.index);
    }
    if (!col.selector) {
        return row[col.id];
    }
    if (typeof col.selector === "function") {
        var cb = col.selector;
        return cb(row);
    }
    var selector = col.selector;
    var tree = selector.split(".");
    if (tree.length > 1) {
        var s = (0, Helpers_1.GetDeepContent)(__assign({}, row), col.selector);
        return s;
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: row[col.selector] });
};
exports.SmartTableCell = SmartTableCell;
